module.exports = __webpack_public_path__ + "static/media/hyperledger.ae546f52.png";